import { ClientShortProfile, CommandCenterClientProfile, PersonOrgSubtype, PersonOrgType } from '@ndvr/customer-api';

import { titleCase } from 'utils/string-utils';

import { getOrgName, getPersonInitials, getPersonName } from './person-utils';

export const getClientName = (clientProfile?: CommandCenterClientProfile | ClientShortProfile) => {
    if (!clientProfile) {
        return '';
    }
    if ('firstName' in clientProfile) {
        return clientProfile.personOrgType === PersonOrgType.PERSON
            ? getPersonName(clientProfile) + ' Individual'
            : clientProfile.personOrgType + getOrgName(clientProfile);
    }

    if ('clientPersonOrgProfile' in clientProfile) {
        return clientProfile?.clientPersonOrgProfile.personOrg.personOrgType === PersonOrgType.PERSON
            ? getPersonName(clientProfile.clientPersonOrgProfile.personOrg)
            : getOrgName(clientProfile?.clientPersonOrgProfile.personOrg);
    }

    return '';
};

export const getClientInitials = (clientProfile?: CommandCenterClientProfile) => {
    return clientProfile?.clientPersonOrgProfile.personOrg.personOrgType === PersonOrgType.PERSON
        ? getPersonInitials(clientProfile?.clientPersonOrgProfile.personOrg)
        : getOrgName(clientProfile?.clientPersonOrgProfile.personOrg).charAt(0);
};

export const getClientType = (personOrg?: {
    personOrgType?: PersonOrgType;
    personOrgSubtype?: PersonOrgSubtype;
}): string => {
    if (personOrg?.personOrgSubtype) {
        return titleCase(personOrg.personOrgSubtype);
    }
    return getClientTypeAlias(personOrg?.personOrgType);
};

export const getClientTypeAlias = (personOrgType?: PersonOrgType): string => {
    switch (personOrgType) {
        case PersonOrgType.PERSON:
            return 'Individual';
        case PersonOrgType.JOINT_PERSONS:
            return 'Joint';
        case PersonOrgType.ORGANIZATION:
            return 'Entity';
        default:
            return titleCase(personOrgType);
    }
};
